<template>
	<div class="dialogs-empty">
		<div class="dialogs-empty__content">
			<div class="dialogs-empty__title">
				<app-icon
					name="comment-success"
					size="20px"
					color="#979797"
				/>
				{{ $t('chat_empty_title') }}
			</div>
			<div class="dialogs-empty__text">
				{{ $t('chat_empty_description') }}
			</div>
			<app-button
				type="secondary"
				:label="$t('chat_create_new')"
				@click="emit('on-create')"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";

const emit = defineEmits<{
	(e: 'on-create'): void,
}>()

</script>

<style scoped lang="scss">
.dialogs-empty {
	flex: 1;
	padding: 8px 40px;

	&__content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
		padding: 48px 0;
		color: #979797;
	}

	&__title {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 16px;
		line-height: 20px;
		font-weight: 400;
	}

	&__text {
		font-size: 14px;
		line-height: 18px;
		font-weight: 400;
		text-align: center;
	}
}
</style>
